var map = {
	"./Hoenn.png": [
		8846,
		484
	],
	"./Hoenn6.png": [
		7412,
		635
	],
	"./Johto.png": [
		9260,
		296
	],
	"./Johto4.png": [
		8114,
		386
	],
	"./Kanto.png": [
		3068,
		49
	],
	"./Kanto3.png": [
		5070,
		437
	],
	"./Kanto3_1.png": [
		3236,
		585
	],
	"./Kanto3_2.png": [
		4750,
		683
	],
	"./Kanto3_3.png": [
		5816,
		956
	],
	"./Sinnoh.png": [
		7632,
		65
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2492;
module.exports = webpackAsyncContext;